import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button'

const Header = ({label, style, action}) => {
  return (
    <Grid container justify='space-between' spacing={2} style={{ marginBottom: 8 }}>
      <Grid item>
        <Typography 
          style={style} 
          variant='h4' 
          component='h4'
        >
          {label}
        </Typography>  
      </Grid>
      {
        action && (
          <Grid item>
            <Button color='primary' variant='contained' onClick={action.onClick}>
              {action.title}
            </Button>
          </Grid>
        )
      }
    </Grid>
  )
};

export default Header;